// Returns the sessionId
export const getSessionId = () => {
  return window.sessionStorage.getItem("sessionId");
};
